export default {
  props: {
    tag: { required: false, type: String, default: 'div' }
  }
};
